/** CBS独立准入：认证且启用，不读取产品开通状态。未知字段不能放行。 */
export const isBookingEntry = (href, code, routeName) => /^\/booking(?:\/|$)/.test(href || '') || String(code || '').toLowerCase() === 'cbs' || routeName === 'booking'

export function getBookingAccessState({ phase, userInfo = {}, companyInfo = {} }) {
  if (phase === 'LOADING') return 'LOADING'
  if (phase === 'LOAD_FAILED') return 'LOAD_FAILED'
  if (!userInfo.userId) return 'ANONYMOUS'
  if (!userInfo.companyCode) return 'NEED_CERTIFICATION'
  if (!companyInfo.companyCode || companyInfo.companyCode !== userInfo.companyCode) return 'LOAD_FAILED'
  const number = value => value === null || value === undefined || value === '' ? NaN : Number(value)
  const enable = number(companyInfo.enable)
  const status = number(companyInfo.status)
  if (!Number.isFinite(enable) || !Number.isFinite(status)) return 'LOAD_FAILED'
  if (enable !== 1 || number(companyInfo.isDeleted) === 1) return 'COMPANY_UNAVAILABLE'
  return status === 20 ? 'ELIGIBLE' : 'NEED_CERTIFICATION'
}
